import type { ReactElement } from 'react';
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { MathJaxContext } from 'better-react-mathjax';
import 'core-js/stable';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'regenerator-runtime/runtime';
import { ErrorBoundary } from 'atom-components/error-boundary/error-boundary';
import { AssistQueryClientProvider } from 'services/assist-api/query-client';
import setupGlitchTip, { TrackUser } from 'services/glitch-tip/setup';
import { AuthProvider } from 'services/providers/auth.provider';
import { ThemeProvider } from 'services/providers/theme.provider';
import setupFontawesome from 'utils/setup-fontawesome';
import Pages from './pages';
import 'index.scss';

// FA ICONS
setupFontawesome();
// setup GlitchTip / Sentry
setupGlitchTip();

function App(): ReactElement {
  return (
    <ErrorBoundary>
      <MathJaxContext src="/assets/mathjax/tex-chtml.js">
        <AssistQueryClientProvider>
          <ReactQueryDevtools initialIsOpen={false} />
          <ThemeProvider>
            <AuthProvider>
              <TrackUser />
              <BrowserRouter>
                <ToastContainer
                  autoClose={3000}
                  limit={2}
                  theme="light"
                  position="bottom-right"
                  closeButton
                  pauseOnFocusLoss
                  pauseOnHover
                />
                <Pages />
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </AssistQueryClientProvider>
      </MathJaxContext>
    </ErrorBoundary>
  );
}

createRoot(document.getElementById('app')).render(<App />);
